import styled from 'styled-components/macro';

import { colorType } from 'components/common/buttons/Button';
import { DefaultButton } from 'components/styled/Button';
import { Flex } from 'components/styled/Flex';

export const ImageContainer = styled(Flex)`
  overflow-y: scroll;
  max-height: 40rem;

  ::-webkit-scrollbar {
    height: 7px;
    width: 9px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: ${({ theme }) => theme.colors.black_10};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:horizontal,
  ::-webkit-scrollbar-thumb:vertical {
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    cursor: pointer;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-height: 15rem;
    ::-webkit-scrollbar {
      height: 7px;
      width: 8px;
    }
  }
`;

export const Image = styled.img``;

export const AnchorButton = styled(DefaultButton)<{
  color: colorType;
  href: string;
  download: string;
}>`
  :hover {
    background-color: ${({ theme }) => theme.colors.black_40};
    color: ${({ theme }) => theme.colors.black_80};
  }

  href: ${({ href }) => (href ? href : '#')};
  download: ${({ download }) => (download ? download : '')};
`;

export const AnchorButtonContainer = styled(Flex)`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    justify-content: center;
  }
`;
